import React, { Component } from "react";
import { Link } from "react-router-dom";
// Style
import "./Links.css";

export default class Links extends Component {
  render() {
    return (
      <React.Fragment>
        {/* <div className="link">
          <img src={covid} />
          <p className="link-title">COVID-19 Information Center</p>
        </div> */}
        <div className="link">
          <Link to="/friends" className="link-to">
            <i className="fas fa-user-friends fa-lg" />
            <p className="link-title">Find Friends</p>
          </Link>
        </div>
        <div className="link">
          <Link to="/pages" className="link-to">
            <i className="fas fa-flag fa-lg" />
            <p className="link-title">Pages</p>
          </Link>
        </div>
        <div className="link">
          <Link to="/groups" className="link-to">
            <i className="fas fa-users fa-lg" />
            <p className="link-title">Groups</p>
          </Link>
        </div>
      </React.Fragment>
    );
  }
}
